export const eventDetailTabTypes = [
  "Details",
  "Chat",
  "Photos",
  "Attendees",
] as const;
